import { CLIENT_ID_POSTER, DESIGNER_MODE, INTERNAL_DESIGNER_MODE, USER_MODE } from '@/types';
import { isDevelopEnv } from './env';
import { getQuery, getQueryParam } from './query';
import { getWebApiHostname } from './request';

/**
 * 获取当前用户的角色
 *
 * - 非本地环境下，根据当前域名判断
 * - 本地环境下，根据 `query` 中的 `mode` 参数值判断
 *
 * @returns `{'user' | 'designer' | 'internal_designer'}` 用户/设计师/内部设计师
 */
export const getCurMode = () => {
    let mode = '';
    const params = getQuery();

    // 本地开发环境
    if (isDevelopEnv()) {
        mode = params.mode as string;
        return mode;
    }

    // 非本地开发环境
    const matches = window.location.hostname.match(/^(.+)\.meitu.com$/);
    const prefix = (matches && matches[1]) || '';

    if (/.*mcp$/.test(prefix)) {
        mode = DESIGNER_MODE;

        // NOTE 等内部设计师角色跳转迁移到新的域名后，再修复成根据域名来判断mode
        if (params.mode === INTERNAL_DESIGNER_MODE) mode = INTERNAL_DESIGNER_MODE;
    } else if (/.*pc$/.test(prefix)) {
        mode = USER_MODE;
    }

    return mode;
};

/** 是否是设计师 */
export const isDesignerMode = function () {
    return getCurMode() === DESIGNER_MODE;
};

/** 是否是内部设计师 */
export const isInternalDesignerMode = function () {
    return getCurMode() === INTERNAL_DESIGNER_MODE;
};

export const isPcPlatform = () => {
    return false;
};

/** 是否是用户 */
export const isUserMode = function () {
    return true;
};

export const getPCToken = async () => {
    return '';
};

export const getAccessToken = function () {
    const parsed = getQuery();
    return parsed.t || parsed.accessToken || localStorage.getItem('access_token');
};

export const getClientId = () => {
    const parsed = getQuery();
    if (parsed.clientId) {
        return parsed.clientId;
    }
    return CLIENT_ID_POSTER;
};

export const getAppId = (): Promise<{ app_id: string }> => {
    const query = getQuery();
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
                    const res = JSON.parse(xhr.responseText);
                    if (res.data && res.data.app_id !== void 0) {
                        resolve(res.data);
                    } else {
                        reject();
                    }
                } else {
                    reject();
                }
            }
        };
        xhr.open('get', `${getWebApiHostname()}/common/get_app_id?client_id=${getClientId()}`, true);

        xhr.setRequestHeader('access_token', query.accessToken || '');

        xhr.send(null);
    });
};

export const getIntlClientID = (): string => {
    const isIntl = getQueryParam('isIntl') === '1';
    return isIntl ? '1189857628' : '';
};

export const getInternalDesignerIdToken = function () {
    const parsed = getQuery();
    return parsed.id;
};
